import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import CalculateIcon from '@mui/icons-material/Calculate';
import { SimulationContainer, SimulationContentContainer } from './styles';
import Charts from '../Charts/Charts';
import InputParameters from '../InputsParameters/InputParameters';
import Schematic from '../Schematic/Schematic';
import { COLORS } from '../../styles/constants';

const Simulation = React.forwardRef(({ simulationNumber }, ref) => {
	const partDefinition = useSelector(state => state.designDefinition.partDefinition);
	const showInputParams = useSelector(
		state => state.designDefinition.partDefinition.simulations[simulationNumber].showInputParams
	);
	const simulationsDefinition = partDefinition.simulations;
	const simulation = simulationsDefinition[simulationNumber];
	const [isDisabled, setIsDisabled] = useState(true);
	const inputParametersRef = useRef(null);

	const handleValidationErrorsChange = errors => {
		setIsDisabled(errors && Object.keys(errors).length > 0);
	};

	return (
		<SimulationContainer ref={ref}>
			<Typography variant="h4" sx={{ mb: 3 }}>
				{simulation.heading}
			</Typography>

			<SimulationContentContainer>
				<InputParameters
					boundariesPath={'input_boundaries/' + partDefinition.defaultMappingName.toLowerCase() + '.json'}
					simulationNumber={simulationNumber}
					simulationName={simulation.heading}
					netlistPath={simulation.netlist.netlistPath}
					inputHeading={simulation.inputHeading}
					chartsDefinition={simulation.charts}
					ref={inputParametersRef}
					onValidationErrorsChange={handleValidationErrorsChange}
					showInputParams={showInputParams ?? false}
				/>
				<Schematic
					simulationNumber={simulationNumber}
					netlistPath={simulation.netlist.netlistPath}
					simulation={simulation}
					showInputParams={showInputParams ?? false}
				/>
			</SimulationContentContainer>
			{simulation.note && (
				<Typography variant="body2" sx={{ color: COLORS.TEXT_SECONDARY }}>
					{ReactHtmlParser(simulation.note)}
				</Typography>
			)}
			<Button
				variant="contained"
				size="large"
				sx={{ mt: 3, color: 'white' }}
				startIcon={<CalculateIcon />}
				onClick={() => inputParametersRef.current.handleCalculateAndRecord()}
				disabled={isDisabled}>
				Calculate
			</Button>
			<Charts simulationNumber={simulationNumber} chartDescription={simulation.charts} />
		</SimulationContainer>
	);
});

export default Simulation;
